import React from "react";
import Calendar from "./Calendar";
import moment from "moment";
import ReactDatetime from "react-datetime";

const CalendarLayout = ({ setSelectedDate, selectedDate, children }) => {
  function getDaysInMonth(month, year) {
    let daysInMonth = new Date(year, month + 1, 0).getDate();
    return Array.from(
      { length: daysInMonth },
      (_, index) => new Date(year, month, index + 1)
    );
  }

  const setSelectedDay = (val) => {
    // console.log('setSelectedDay: ', val);
    setSelectedDate(val);
  };

  return (
    <div className="bg-[#eaf3fa] h-full">
      <div className="bg-header h-[40vh] xs:h-[30vh] p-2 [@media(max-height:580px)]:h-[200px] [@media(max-height:580px)]:pb-12">
        <div className="">
          <div className="flex items-center mx-3">
            <i className="icon-calender text-white text-xl" />
            <ReactDatetime
              className="calendar-css border-0 mx-2 bg-header p-0 m-0 w-100"
              dateFormat={`MMMM YYYY`}
              timeFormat=""
              closeOnSelect={true}
              closeOnClickOutside={true}
              inputProps={{
                readOnly: true,
              }}
              value={moment(selectedDate)}
              onChange={(date) => setSelectedDay(moment(date))}
            />
            {/* <FaAngleDown fontSize={20} color='#000000' /> */}
          </div>
          <Calendar
            daysArray={getDaysInMonth(
              new Date(selectedDate).getMonth(),
              new Date(selectedDate).getFullYear()
            )}
            selectedDate={selectedDate}
            setSelectedDay={setSelectedDay}
          />
        </div>
      </div>
      <div className="bg-white mx-3 px-3 py-4 rounded-2xl relative top-[-60px] xsm:top-[-20px] [@media(max-height:580px)]:mb-12 ">
        {children}
      </div>
    </div>
  );
};

export default CalendarLayout;
